/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

/* eslint-disable no-unused-vars */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Material Check Icon component.
 */
export const MaterialCheckIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M20 7.262L9.029 18 4 13.078l1.29-1.261 3.739 3.65L18.71 6 20 7.262z'
        fill={iconColor} />
    </svg>
  );
};
